
import { Loader2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface LoadingSpinnerProps {
  message?: string;
  size?: "sm" | "md" | "lg";
}

export function LoadingSpinner({ message, size = "md" }: LoadingSpinnerProps) {
  const { t } = useLanguage();
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8", 
    lg: "h-12 w-12"
  };

  const displayMessage = message || t('loading.default');
  
  return (
    <div className="flex flex-col items-center space-y-4">
      <Loader2 className={`${sizeClasses[size]} animate-spin`} />
      <p className="text-muted-foreground">{displayMessage}</p>
    </div>
  );
}
